import axios from "axios";
import React, { useState } from "react";
import payment from "../../assets/payment.jpeg";

const PaymentModal = ({ showModal, setShowModal, id, selectValue }) => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    itemDetails_type: selectValue,
    itemDetails_id: id,
  });

  const [screenshot, setScreenshot] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ loading state

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // ✅ start loading

    const data = new FormData();
    data.append("name", formData.name);
    data.append("number", formData.number);
    data.append("email", formData.email);
    data.append("itemDetails_type", formData.itemDetails_type);
    data.append("itemDetails_id", formData.itemDetails_id);

    if (screenshot) {
      data.append("screenshot", screenshot);
    }

    try {
      await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/payments`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert("Form submitted successfully!");
      setShowModal(false);
    } catch (error) {
      console.error(error);
      alert("Submission failed!");
    } finally {
      setIsSubmitting(false); // ✅ stop loading
    }
  };

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-[#081a28] text-white p-6 rounded-lg max-w-md w-full">
            <h2 className="text-xl font-bold text-white mb-4">কোর্সটি কিনুন</h2>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <input
                name="name"
                type="text"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-white text-white bg-transparent rounded"
              />
              <input
                name="number"
                type="text"
                placeholder="Phone Number"
                value={formData.number}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-white text-white bg-transparent rounded"
              />
              <input
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-white text-white bg-transparent rounded"
              />

              <div className="flex flex-col gap-1">
                <span className="text-xl font-bold text-white">
                  Please Go to bKash and scan the QR code
                </span>
                <div className="w-full h-[20rem] flex items-center justify-center bg-[#f1f5f9]">
                  <img
                    src={payment}
                    alt="scanner"
                    loading="lazy"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <span className="text-base">Attach the payment screenshot</span>
                <input
                  name="screenshot"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="w-full px-4 py-2 border border-white text-white bg-transparent rounded"
                />
              </div>

              <div className="flex justify-end gap-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-4 py-2 rounded transition font-semibold ${
                    isSubmitting
                      ? "bg-gray-400 text-white cursor-not-allowed"
                      : "bg-white text-[#081a28]"
                  }`}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>

                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border border-white text-white rounded"
                >
                  বন্ধ করুন
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentModal;
